import React from 'react';
import createApiRequest from '@/lib/axios/createApiRequest';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';

export default function useConstituentIWaveData(constituentId?: string) {
  const { data: { iwaveProfile } = {}, isLoading } =
    useConstituent(constituentId);
  const ownerOrgId = useOwnerOrgId();

  const onRefreshData = React.useCallback(() => {
    return createApiRequest({
      path: '/integrations/iwave/import-score',
      data: {
        ownerOrgId,
        constituentId,
        iwaveUniqueScreeningId: iwaveProfile.uniqueScreeningId,
      },
      throwErrors: true,
    });
  }, [iwaveProfile]);

  return {
    iwaveProfile,
    isLoading,
    onRefreshData,
  };
}
